import * as React from 'react';
import TaxonomyJS, { ITaxonomyCanvasConfig, ITaxonomyCanvasData, ITaxonomyTag } from './taxonomy.compiled.js';
import Snackbar from '../Snackbar';

// Component
export interface IProps extends ITaxonomyCanvasConfig {
    taxonomyData?: ITaxonomyCanvasData | null;
    headings?: boolean;
}

export interface IState {
    showTooltip: boolean;
    showTooltipTag: ITaxonomyTag | null;
}

class TaxonomyCanvas extends React.Component<IProps, IState> {
    canvasRef: HTMLCanvasElement;
    taxonomyMenu: TaxonomyJS;

    state: IState = {
        showTooltip: false,
        showTooltipTag: null
    };

    componentDidMount() {
        this.taxonomyMenu = new TaxonomyJS(this.canvasRef, {
            onTitleClick: this.props.onTitleClick,
            onTitleMouseEnter: this.handleTitleMouseEnter,
            onTitleMouseLeave: this.handleTitleMouseLeave,
            onNavigate: this.props.onNavigate,
            headings: this.props.headings
        });
        this.taxonomyMenu.create(this.props.taxonomyData!);
    }

    addItem(parentTagId: string, tag: ITaxonomyTag) {
        this.taxonomyMenu.addItem(parentTagId, tag);
    }

    editItem(tag: ITaxonomyTag) {
        this.taxonomyMenu.editItem(tag);
    }

    moveTag(tag: ITaxonomyTag, newParentTagId: string) {
        this.taxonomyMenu.moveItem(tag, newParentTagId);
    }

    removeTag(tagId: string) {
        this.taxonomyMenu.removeItem(tagId);
    }

    handleTitleMouseEnter = (tagData: ITaxonomyTag) => {
        if (tagData.description) {
            this.setState({
                showTooltip: true,
                showTooltipTag: tagData
            });
        }
        if (this.props.onTitleMouseEnter) {
            this.props.onTitleMouseEnter(tagData);
        }
    }

    handleTitleMouseLeave = () => {
        this.setState({
            showTooltip: false
        });

        if (this.props.onTitleMouseLeave) {
            this.props.onTitleMouseLeave();
        }
    }

    render() {
        return (
            <div>
                <canvas
                    id="canvas"
                    height="400"
                    style={{ display: 'block' }}
                    ref={(c) => {
                        this.canvasRef = c!;
                    }}
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                    open={this.state.showTooltip}
                    message={(
                        <span id="message-id">
                            {this.state.showTooltipTag !== null ? this.state.showTooltipTag!.description : ''}
                            </span>
                    )}
                />
            </div>
        );
    }
}

export default TaxonomyCanvas;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TaxonomyCanvas/TaxonomyCanvas.tsx